import React from 'react';

// This context can be used to get information about the user device, mainly if it is mobile or desktop
const DeviceInfoContext = React.createContext();

export default DeviceInfoContext;